import Vue from 'vue'
import Router from 'vue-router'

import index from '../pages/index.vue'
import technology from "../pages/technology.vue"
import products from '../pages/products.vue'
import proDetail from "../pages/pro_detail.vue"
import service from '../pages/service.vue'
import cintroduction from '../pages/cintroduction.vue'
import cnews from '../pages/cnews.vue'
import cnDetail from '../pages/cn_detail.vue'
import cculture from '../pages/cculture.vue'
import contactus from '../pages/contactUs.vue'
import joinus from '../pages/joinus.vue'
Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'index',
    component: index
  }, {
    path: '/technology',
    name: 'technology',
    component: technology
  }, {
    path: '/products',
    name: 'products',
    component: products
  }, {
    path: '/proDetail',
    name: 'proDetail',
    component: proDetail
  }, {
    path: '/service',
    name: 'service',
    component: service
  }, {
    path: '/cintroduction',
    name: 'cintroduction',
    component: cintroduction
  }, {
    path: '/cnews',
    name: 'cnews',
    component: cnews
  }, {
    path: '/cnDetail',
    name: 'cnDetail',
    component: cnDetail
  }, {
    path: '/cculture',
    name: 'cculture',
    component: cculture
  }, {
    path: '/contactus',
    name: 'contactus',
    component: contactus
  }, {
    path: '/joinus',
    name: 'joinus',
    component: joinus
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js